import Button from "@src/components/elements/input/Button";
import Checkbox from "@src/components/elements/input/Checkbox";
import Input from "@src/components/elements/input/Input";
import BackButton from "@src/components/nav/BackButton";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const Newsletter = () => {
  const [privacyCheck, setPrivacyCheck] = useState(false);
  const [email, setEmail] = useState("");
  const { t } = useTranslation();

  return (
    <>
      <div className="pl-4 pt-4">
        <BackButton stepback desktopVisible />
      </div>
      <section className="relative">
        <img
          src="/images/info/newsletter_2_tradefoox.jpg"
          className="h-[300px] w-full object-cover"
        />
        <div className="absolute left-6 top-1/2 flex -translate-y-1/2 flex-col font-semibold italic">
          <div className="w-fit bg-white bg-opacity-80 px-1 text-2xl text-darkcyan">
            {t("pages.newsletter.text1")}
          </div>
          <div className="ml-4 w-fit bg-darkblue bg-opacity-80 px-1 text-white">
            {t("pages.companyFAQ.tradefoox")}
          </div>
        </div>
      </section>

      <div className="grid grid-flow-row gap-6 pb-4 text-gray-700 max-xl:px-4">
        <article className="grid grid-flow-row gap-3 text-sm">
          <h1 className="text-base font-semibold">{t("pages.newsletter.text2")}</h1>
          {t("pages.newsletter.text3")}
        </article>
        <form className="text-sm">
          {t("pages.newsletter.text4")}
          <Input
            type="email"
            name="email"
            placeholder="E-Mail*"
            value={email}
            required
            onChange={e => {
              setEmail(e);
            }}
          />
          <Checkbox name="agb" required checked={privacyCheck} onChange={e => setPrivacyCheck(e)}>
            {t("pages.createAccount.text17")}{" "}
            <NavLink to="/datenschutz" target="_blank">
              {t("pages.createAccount.text18")}
            </NavLink>{" "}
            {t("pages.createAccount.text19")}
          </Checkbox>
          <Button submit>{t("pages.newsletter.signIn")}</Button>
        </form>
      </div>
    </>
  );
};

export default Newsletter;
